<template>
<section id="clConditions">
  <h2 class="instH2">Условия</h2>
  <ul>
    <li>
      <p>Сумма</p>
      <p>от 35 000 до 100 000 ₽</p>
    </li>
    <li>
      <p>Возраст</p>
      <p>до 70 лет</p>
    </li>
    <li>
      <p>Документ</p>
      <p>нужен только паспорт</p>
    </li>
    <li>
      <p>Ставка</p>
      <p>202% годовых</p>
    </li>
  </ul>
  <instApplyButton></instApplyButton>
</section>
</template>

<script>
// возраст (нижняя граница) и ставка 200% — из ТЗ, требуют подтверждения заказчика (п.8),
// сейчас значения проставлены как в исходном документе
export default {
  name: "clConditions",
  components: {
    instApplyButton: () => import('@/components/inst/instApplyButton.vue'),
  }
}
</script>

<style scoped>
ul{background: white;padding: var(--font-size-40) 0;border-radius: var(--font-size-20);font-family: 'Roboto';}
li{border-radius: var(--font-size-20);background: var(--color-gray-type4);width: var(--font-size-300);padding: var(--font-size-20) var(--font-size-24);margin: 0 auto var(--font-size-20);}
li:last-child{margin-bottom: 0;}
li p:first-child{font-weight: 500;font-size: var(--font-size-18);margin-bottom: var(--font-size-10)}
li p:last-child{font-weight: 100;font-size: var(--font-size-16);color:var(--color-gray-type3);}

@media screen and (min-width: 760px) {
  ul{display: flex;align-items: stretch;justify-content: flex-start;flex-wrap: nowrap;padding: var(--font-size-40);gap: var(--font-size-15);}
  li{width: calc((100% - (var(--font-size-15) * 3)) / 4);margin: 0;}
}
</style>
